import React from "react";
import { About, Contact, HeroSection, NoteProjects, Work } from "../components/pageComponents/home";
import { Footer, Header, MailBar, SocialSidebar } from "../components/shared";

const HomePage = () => {
  return (
    <>
      <Header />
      <SocialSidebar />
      <MailBar />
      <main>
        <HeroSection />
        <About />
        <Work />
        <NoteProjects />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
